// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphViewReference.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphViewReference.tsx");
  import.meta.hot.lastModified = "1773385375630.2139";
}
// REMIX HMR END

import { BlogGroup, CardGroup } from "~/components/views";
const displayMap = {
  blog_teaser: BlogGroup,
  insights: CardGroup,
  // @todo: Remove this once the new references view is implemented
  view_article_card_group: CardGroup,
  default: CardGroup
};
const calculateComponent = display => {
  if (displayMap[display]) {
    return displayMap[display];
  }
  if (display.startsWith("insights")) {
    return displayMap["insights"];
  }
  return displayMap["default"];
};
export default function ViewReference(props) {
  const Component = calculateComponent(props.display);
  if (Component) {
    return <Component {...props} />;
  }
  return <p className="border-y border-neutral-500 p-4 break-words">
      {JSON.stringify(props)}
    </p>;
}
_c = ViewReference;
var _c;
$RefreshReg$(_c, "ViewReference");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;